import { isError } from 'lodash'
import { getDraftsEducationalContent, getPublishedEducationalContent } from '../../services/KreaEducationalContent'
import { mapContentListForCard } from '@/utils/educationalContent'

export default {
  state: {
    publishedContent: {
      totalCount: 0,
      data: null,
      pages: 0
    },
    draftsContent: {
      totalCount: 0,
      data: null,
      pages: 0
    },
    navigationOptions: {
      list: true,
      card: false
    }
  },
  mutations: {
    hydratePublishedEducationalContent(state, data) {
      state.publishedContent.totalCount = data.totalCount
      state.publishedContent.data = data.data
      state.publishedContent.pages = data.pages
    },
    hydrateDraftsEducationalContent(state, data) {
      state.draftsContent.totalCount = data.totalCount
      state.draftsContent.data = data.data
      state.draftsContent.pages = data.pages
    },
    setKreaNavigationOptions(state, option) {
      state.navigationOptions[option] = true
    },
    resetKreaNavigationOptions(state) {
      state.navigationOptions.card = false
      state.navigationOptions.list = false
    }
  },
  actions: {
    async hydratePublishedEducationalContent({ commit }, params = {}) {
      const response = await getPublishedEducationalContent(params).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      if (successfulRequest) commit('hydratePublishedEducationalContent', response.data)
      return successfulRequest
    },
    async hydrateDraftsEducationalContent({ commit }, params = {}) {
      const response = await getDraftsEducationalContent(params).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      if (successfulRequest) commit('hydrateDraftsEducationalContent', response.data)
      return successfulRequest
    },
    setKreaNavigationOptions({ commit }, { option }) {
      commit('resetKreaNavigationOptions')
      commit('setKreaNavigationOptions', option)
    }
  },
  getters: {
    getPublishedContentListForCard(state) {
      return state.publishedContent.data.map(mapContentListForCard)
    },
    getDraftsContentListForCard(state) {
      return state.draftsContent.data.map(mapContentListForCard)
    }
  }
}
